function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
/* eslint-disable react/prop-types */
import React from 'react';
import InputLabel from "./InputLabel";
import Radio from "./Radio";
import ErrorContainer from "./ErrorContainer";
import { _InputWrapperDiv } from "./inputStyles";
import ToolTip from "../ui/ToolTip/ToolTip";
var RadioInput = function RadioInput(props) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_InputWrapperDiv, null, /*#__PURE__*/React.createElement(InputLabel, {
    labelText: props.labelText,
    required: props.required
  }, props.tooltip && Object.keys(props.tooltip).length && /*#__PURE__*/React.createElement(ToolTip, {
    text: props.tooltip['data-tip'],
    name: props.tooltip.name
  })), /*#__PURE__*/React.createElement(ErrorContainer, {
    error: props.error
  })), /*#__PURE__*/React.createElement(_InputWrapperDiv, null, /*#__PURE__*/React.createElement(Radio, _extends({
    id: props.inputId,
    key: props.labelText
  }, props))));
};
export default RadioInput;